import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

import { fetchClientsAccountsList } from '../services/accIqService';
import { useParams, useLocation } from 'react-router-dom';
import { useUser } from './UserContext';
import api from '../services/api';
import { setRecordAsFavourite, getUserStatsObject, recordActivity } from '../services/commonService';
import { getCheckoutClientId, getCheckoutClientInfo } from '../services/authService';

export const AccountListContext = createContext(null);

export const AccountListProvider = ({ children }) => {
    const { user, setMyAllFavourites } = useUser();
    const [allAccounts, setAllAccounts] = useState([]);
    const [favouriteAccounts, setFavouriteAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiError, setApiError] = useState('');
    const [client_id, setCheckoutClientId] = useState(getCheckoutClientId())
    // local_db_records, accounts_list
    const [local_db_records, setLocalDbRecords] = useState([])
    const [accounts_list, setAccountsList] = useState([])

    const [localDBLoaded, setLoacalDBLoaded] = useState(false);
    const [accountListLoaded, setAccountListLoaded] = useState(false);

    const fetchClientsAcc = async () => {

      setLoading(true);
      try {

        const {checkoutClientId, checkoutClientName} = getCheckoutClientInfo();

        const clientNameNew = checkoutClientName || (user?.company_name || '');
        const clientCode = checkoutClientId || (user?.company_id || '');

        if(clientCode != ""){
          let filter = {
            'client_code' : clientCode,
            'list_type': 'basic'
          };

          const response = await api.get('/accounts/get_accounts_v2', {
            params: {          
              page: 1,
              limit: 2000, // perPage
              ...filter,
            },
          });

          let local_db_records = response?.data?.result.list || [];

          setLocalDbRecords(local_db_records)

          setLoacalDBLoaded(true)
        }

        // setLoading(false);

      } catch (error) {
        console.error('Error fetching accounts list:', error);
        // setLoading(false);
      }

      // setLoading(false);
    }

    const fetchProcessedClientsAcc = async () => {

      // setLoading(true);
      try {

        const {checkoutClientId, checkoutClientName} = getCheckoutClientInfo();

        const clientNameNew = checkoutClientName || (user?.company_name || '');
        const clientCode = checkoutClientId || (user?.company_id || '');

        if(clientCode != ""){
          // Process accounts list
          const accounts = await fetchClientsAccountsList('', clientNameNew);
          const accounts_list = accounts?.accounts || [];

          setAccountsList(accounts_list)

          setAccountListLoaded(true)
        }

        // setLoading(false);

      } catch (error) {
        console.error('Error fetching accounts list:', error);
        // setLoading(false);
      }

      // setLoading(false);
    }

    useEffect(() => {
      const getClientAccData = async () => {
        setLoading(true);
        await Promise.all([fetchClientsAcc(), fetchProcessedClientsAcc()]);
      }
      
      if ((user?.company_id && user?.checkoutClientInfo) || user?.role_key) {
      //   getClientAccData();
      }
    }, [user?.role_key, user?.company_id, user?.checkoutClientInfo]); // Trigger only when user company ID changes

    useEffect(() => {

      if(local_db_records?.length && accounts_list?.length){
        // Map records by request_id
          const mapped_with_request_id = local_db_records.reduce((acc, curr) => {
            acc[curr.request_id] = curr;
            return acc;
          }, {});

          const request_id_arr = Object.keys(mapped_with_request_id)

          const filteredAccounts = accounts_list?.map((account, index) => {
            let acc_request_id = account?.request_id;
            if(acc_request_id !== undefined && acc_request_id !== "undefined" && typeof mapped_with_request_id[acc_request_id]?.id !== undefined){
              let record_id = typeof mapped_with_request_id[acc_request_id]?.id !== undefined ? mapped_with_request_id[acc_request_id]?.id : '';
              account._id = record_id;  // Assign the correct ID to account._id
              account.isFavourite = typeof mapped_with_request_id[acc_request_id]?.is_bookmarked_by_logged_in_user !== undefined && mapped_with_request_id[acc_request_id]?.is_bookmarked_by_logged_in_user === 1 ? mapped_with_request_id[acc_request_id]?.is_bookmarked_by_logged_in_user : 0;
              account.status = typeof mapped_with_request_id[acc_request_id]?.status !== undefined ? mapped_with_request_id[acc_request_id]?.status : 0;
              account.file_path = typeof mapped_with_request_id[acc_request_id]?.file_path !== undefined ? mapped_with_request_id[acc_request_id]?.file_path : "";
              account.client_code = typeof mapped_with_request_id[acc_request_id]?.client_code !== undefined ? mapped_with_request_id[acc_request_id]?.client_code : "";
              account.client_name = typeof mapped_with_request_id[acc_request_id]?.client_name !== undefined ? mapped_with_request_id[acc_request_id]?.client_name : "";
              account.opportunity_count = typeof mapped_with_request_id[acc_request_id]?.opportunity_count !== undefined ? mapped_with_request_id[acc_request_id]?.opportunity_count : "";
              account.contact_count = typeof mapped_with_request_id[acc_request_id]?.contact_count !== undefined ? mapped_with_request_id[acc_request_id]?.contact_count : "";
            }
 

            return account;
            
          }).filter((account) => {
  
            
            const hasAccountAccess = user?.role_key === 'CLIENT' // bypass check
                  ? true
                  : (user?.role_key === 'SALES_DEMO' || user?.role_key === 'ANALYST') && account?.status === 1
                    ? true
                    : user?.assigned_accounts?.includes(account?.company_code);

            return account?._id && hasAccountAccess === true
          });

          setAllAccounts(filteredAccounts);

          setFavouriteAccounts(filteredAccounts?.filter(account => account.isFavourite));

          setLoading(false);

      }
      

    }, [local_db_records, accounts_list, user?.role_key])

    useEffect(() => {
      if((localDBLoaded == true && accountListLoaded == true)  ){
        setLoading(false);
      }
    }, [local_db_records, accounts_list, localDBLoaded, accountListLoaded])


    const toggleFavourite = async (accountId) => {
      setLoading(true);
  
      try {
          const updatedAccounts = await Promise.all(
              allAccounts.map(async (account) => {
                  if (account._id === accountId) {
                      const isFavourite = !account.isFavourite;
  
                      const favObj = {
                          record_type: 'account',
                          account_id: accountId,
                          is_bookmarked: isFavourite ? 1 : 0,
                          account_name: account?.name
                      };
  
                      const flg = await setRecordAsFavourite(favObj);
  
                      if (flg) {
                          return { ...account, isFavourite };
                      } else {
                          setApiError('An error occurred while bookmarking the account.');
                          return account; // Return account without changes on failure
                      }
                  }
                  return account;
              })
          );
  
          setAllAccounts(updatedAccounts);
          setFavouriteAccounts(updatedAccounts.filter((acc) => acc.isFavourite));
          await setMyAllFavourites();
      } catch (error) {
          setApiError('An unexpected error occurred.');
          setLoading(false);
      } finally {
          setLoading(false);
      }
      setLoading(false);
    };
  
    const updateMyReportContext = async () => {
        fetchClientsAcc();
        fetchProcessedClientsAcc();
    }

    const contextValue = useMemo(
      () => ({ allAccounts, favouriteAccounts, toggleFavourite, updateMyReportContext, loading }),
      [allAccounts, favouriteAccounts, toggleFavourite, updateMyReportContext, loading]
    );

    return (
        <AccountListContext.Provider value={contextValue}>
            {children}
        </AccountListContext.Provider>
    );
};
